// extracted by mini-css-extract-plugin
export default {"template1":"styles_template1__OtJLm"};